function Banner(){
    return (
        <div className= "banner">
            <div className = "banner-content">
                <img src = "/banner.png" alt="Banner" className="banner-image"/>
            </div>
        </div>
    );
}

export default Banner;